(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hview-feature-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-feature-accordion')) {
    customElements.define('hview-feature-accordion', class extends HTMLElement {
      connectedCallback() {
        this.stop();
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.items = [...this.querySelectorAll('.hvfa__item')];
        this.buttons = [...this.querySelectorAll('.hvfa__trigger')];
        this.bodies = [...this.querySelectorAll('.hvfa__body')];
        this.media = this.querySelector('.hvfa__media');
        this.slots = [...this.querySelectorAll('.hvfa__inline-media')];
        this.slides = this.items.map(item => this.querySelector(`[data-media-id="${item.dataset.blockId}"]`));
        this.config = this.querySelector('.hvfa__rotation').dataset;
        this.rotationButton = this.querySelector('.hvfa__rotation-button');
        this.mobile = matchMedia('(max-width:749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.index = Math.max(0, this.buttons.findIndex(button => button.getAttribute('aria-expanded') === 'true'));
        this.visible = false;
        this.hovered = false;
        this.focusPaused = false;
        this.editorPaused = false;
        this.userPaused = false;
        this.buttons.forEach((button, index) => {
          button.addEventListener('click', () => this.select(index, true), options);
          button.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowDown') next = (index + 1) % this.buttons.length;
            if (event.key === 'ArrowUp') next = (index - 1 + this.buttons.length) % this.buttons.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.buttons.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.buttons[next].focus();
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.items.findIndex(item => item.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.editorPaused = true; this.select(index); }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.schedule(); }, options);
        this.rotationButton.addEventListener('click', () => { this.userPaused = !this.userPaused; this.schedule(); }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, options);
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
        this.addEventListener('pointerdown', () => { this.focusPaused = false; this.schedule(); }, options);
        this.addEventListener('focusin', event => { if (event.target.matches(':focus-visible')) { this.focusPaused = true; this.schedule(); } }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focusPaused = false; this.schedule(); } }, options);
        this.mobile.addEventListener('change', () => { this.moveMedia(); this.schedule(); }, options);
        this.reduced.addEventListener('change', () => this.schedule(), options);
        document.addEventListener('visibilitychange', () => this.schedule(), options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.schedule();
        });
        this.observer.observe(this);
        this.moveMedia();
        this.schedule();
      }
      disconnectedCallback() { this.stop(); this.observer?.disconnect(); this.controller?.abort(); }
      moveMedia() {
        this.slides.forEach((slide, i) => (this.mobile.matches ? this.slots[i] : this.media).append(slide));
      }
      stop() { clearTimeout(this.timer); this.timer = null; }
      schedule() {
        this.stop();
        const enabled = this.config[this.mobile.matches ? 'mobile' : 'desktop'] === 'true' && this.buttons.length > 1 && !this.reduced.matches;
        this.rotationButton.hidden = !enabled || this.config.showControls === 'false';
        this.rotationButton.textContent = this.userPaused ? this.config.resume : this.config.pause;
        if (!enabled || !this.visible || document.hidden || this.userPaused || this.hovered || this.focusPaused || this.editorPaused) return;
        const seconds = Number(this.config[this.mobile.matches ? 'mobileSeconds' : 'desktopSeconds']) || 6;
        this.timer = setTimeout(() => this.select((this.index + 1) % this.buttons.length), Math.max(3, seconds) * 1000);
      }
      select(index, toggle = false) {
        if (!this.buttons[index]) return;
        const collapse = toggle && this.buttons[index].getAttribute('aria-expanded') === 'true';
        this.index = index;
        this.buttons.forEach((button, i) => {
          const expanded = i === index && !collapse;
          button.setAttribute('aria-expanded', String(expanded));
          this.bodies[i].hidden = !expanded;
          this.slides[i].hidden = i !== index;
        });
        this.schedule();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-feature-media-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-feature-media-grid')) {
    customElements.define('hview-feature-media-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.items = [...this.querySelectorAll('.hvfg__video')].map(video => {
          const media = video.closest('.hvfg__media');
          const button = media.querySelector('.hvfg__toggle');
          const item = { video, media, button, visible: false, intent: null, pending: false, failedAuto: false, nativeControls: video.controls };
          video.controls = false;
          video.muted = true;
          video.playsInline = true;
          button.hidden = false;
          const sync = () => {
            media.toggleAttribute('data-playing', !video.paused && !video.ended);
            button.setAttribute('aria-label', media.dataset.label + (video.paused ? '：動画を再生' : '：動画を一時停止'));
          };
          video.addEventListener('play', sync, options);
          video.addEventListener('pause', sync, options);
          video.addEventListener('ended', () => { item.intent = false; sync(); }, options);
          video.addEventListener('error', () => { item.failedAuto = true; media.querySelector('.hvfg__error').hidden = false; sync(); }, options);
          button.addEventListener('click', () => {
            item.visible = true;
            if (!video.paused || item.pending) { item.intent = false; video.pause(); }
            else { item.intent = true; item.failedAuto = false; this.play(item, true); }
          }, options);
          sync();
          return item;
        });
        this.observer = new IntersectionObserver(entries => {
          for (const entry of entries) {
            const item = this.items.find(item => item.media === entry.target);
            if (!item) continue;
            item.visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
            this.update(item);
          }
        }, { threshold: [0, 0.15] });
        this.items.forEach(item => this.observer.observe(item.media));
        this.motion.addEventListener('change', () => this.items.forEach(item => this.update(item)), options);
        document.addEventListener('visibilitychange', () => this.items.forEach(item => this.update(item)), options);
        // Product tabs hide the ancestor Section. IntersectionObserver naturally
        // handles those display changes and the theme's internal scroll container.
      }
      wantsPlay(item) {
        return item.intent === true || (item.intent !== false && item.media.dataset.autoplay === 'true' && !this.motion.matches && !navigator.connection?.saveData && !item.failedAuto);
      }
      update(item) {
        if (!item.visible || document.hidden || !this.wantsPlay(item)) item.video.pause();
        else this.play(item, false);
      }
      async play(item, explicit) {
        if (item.pending || !item.video.paused) return;
        item.pending = true;
        item.media.querySelector('.hvfg__error').hidden = true;
        try {
          await item.video.play();
          if (!this.isConnected || !item.visible || document.hidden || !this.wantsPlay(item)) item.video.pause();
        } catch (error) {
          if (error.name !== 'AbortError') {
            item.failedAuto = true;
            if (explicit) item.media.querySelector('.hvfg__error').hidden = false;
          }
        } finally { item.pending = false; }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.abort = null;
        this.observer?.disconnect();
        this.items?.forEach(({ video, button, media, nativeControls }) => {
          video.pause();
          video.controls = nativeControls;
          button.hidden = true;
          media.removeAttribute('data-playing');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-media-compare"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-media-compare')) {
    customElements.define('hview-media-compare', class extends HTMLElement {
      connectedCallback() {
        this.stopRotation();
        this.observer?.disconnect();
        this.pauseAll();
        this.abort?.abort();
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.mobile = matchMedia('(max-width: 749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.rotationControl = this.querySelector('.hvmc__rotation');
        this.rotationButton = this.querySelector('.hvmc__rotation-button');
        this.rotationPaused = false;
        this.hoverPaused = false;
        this.focusPaused = false;
        this.editorPaused = false;
        this.rotationButton?.addEventListener('click', () => { this.rotationPaused = !this.rotationPaused; this.scheduleRotation(); }, options);
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && this.dataset.rotateHover === 'true') { this.hoverPaused = true; this.scheduleRotation(); } }, options);
        this.addEventListener('pointerleave', () => { this.hoverPaused = false; this.scheduleRotation(); }, options);
        this.addEventListener('pointerdown', () => { this.focusPaused = false; this.scheduleRotation(); }, options);
        this.addEventListener('focusin', event => { if (event.target.matches(':focus-visible')) { this.focusPaused = true; this.scheduleRotation(); } }, options);
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focusPaused = false; this.scheduleRotation(); } }, options);
        this.index = Math.max(0, this.tabs.findIndex(tab => tab.getAttribute('aria-selected') === 'true'));
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }, options);
        });
        this.panels.forEach(panel => {
          panel.querySelector('.hvmc__play')?.addEventListener('click', () => {
            const video = panel.querySelector('video');
            if (!video) return;
            if (video.paused) { panel.dataset.userPaused = 'false'; video.play().catch(() => this.sync(panel)); }
            else { panel.dataset.userPaused = 'true'; video.pause(); }
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.editorPaused = true; this.select(index); }
        }, options);
        this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.scheduleRotation(); }, options);
        this.mobile.addEventListener('change', () => this.select(this.index), options);
        this.reduced.addEventListener('change', () => { this.pauseAll(); this.maybePlay(); this.scheduleRotation(); }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.pauseAll(); else this.maybePlay();
          this.scheduleRotation();
        }, options);
        if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.maybePlay(); else this.pauseAll();
          this.scheduleRotation();
        }, { threshold: 0 });
        this.observer.observe(this);
        } else { this.visible = true; }
        this.select(this.index);
      }
      disconnectedCallback() { this.stopRotation(); this.pauseAll(); this.abort?.abort(); this.observer?.disconnect(); }
      stopRotation() { clearTimeout(this.rotationTimer); this.rotationTimer = null; }
      scheduleRotation() {
        this.stopRotation();
        const device = this.mobile.matches ? 'Mobile' : 'Desktop';
        const enabled = this.dataset['rotate' + device] === 'true' && this.tabs.length > 1 && !this.reduced.matches;
        if (this.rotationControl) this.rotationControl.hidden = !enabled || this.dataset.rotateControls === 'false';
        if (this.rotationButton) this.rotationButton.textContent = this.rotationPaused ? (this.dataset.rotateResume || '自動切替を再開') : (this.dataset.rotatePause || '自動切替を一時停止');
        if (!enabled || !this.visible || document.hidden || this.rotationPaused || this.hoverPaused || this.focusPaused || this.editorPaused) return;
        const seconds = Number(this.dataset['rotate' + device + 'Seconds']) || 6;
        this.rotationTimer = setTimeout(() => this.select((this.index + 1) % this.tabs.length), Math.max(3, seconds) * 1000);
      }
      pauseAll() { this.querySelectorAll('video').forEach(video => video.pause()); }
      select(index) {
        if (!this.tabs[index] || !this.panels[index]) return;
        this.pauseAll();
        this.index = index;
        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
          this.tabs[i].setAttribute('aria-selected', String(i === index));
          this.tabs[i].tabIndex = i === index ? 0 : -1;
        });
        const panel = this.panels[index];
        if (!panel) return;
        const variant = this.mobile.matches && panel.querySelector('[data-video="mobile"]') ? 'mobile' : 'desktop';
        const template = panel.querySelector(`template[data-video="${variant}"]`);
        if (template && panel.dataset.loaded !== variant) {
          panel.querySelector('.hvmc__video-host').replaceChildren(template.content.cloneNode(true));
          panel.dataset.loaded = variant;
          const video = panel.querySelector('video');
          video.controls = false;
          video.muted = true;
          ['play', 'pause', 'ended', 'error'].forEach(name => video.addEventListener(name, () => this.sync(panel), { signal: this.abort.signal }));
          panel.querySelector('.hvmc__play').hidden = false;
        }
        this.sync(panel);
        this.maybePlay();
        this.scheduleRotation();
      }
      sync(panel) {
        const video = panel.querySelector('video');
        const button = panel.querySelector('.hvmc__play');
        if (!video || !button) return;
        button.setAttribute('aria-label', video.paused ? this.dataset.play : this.dataset.pause);
        button.firstElementChild.textContent = video.paused ? '▶' : 'Ⅱ';
      }
      maybePlay() {
        const panel = this.panels[this.index];
        const video = panel?.querySelector('video');
        if (!video || !this.visible || document.hidden || this.reduced.matches || this.dataset.autoplay !== 'true' || panel.dataset.userPaused === 'true') return;
        video.play().catch(() => this.sync(panel));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-media-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-media-showcase')) {
    customElements.define('hview-media-showcase', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        this.host = this.querySelector('.hvms__video-host');
        if (!this.host) return;
        const options = { signal: this.controller.signal };
        this.button = this.querySelector('.hvms__play');
        this.mobile = matchMedia('(max-width:749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.userPaused = false;
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.video.play().catch(() => this.sync());
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.mobile.addEventListener('change', () => this.loadVideo(), options);
        this.reduced.addEventListener('change', () => { this.video.pause(); this.maybePlay(); }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause(); else this.maybePlay();
        }, options);
        this.loadVideo();
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.maybePlay(); else this.video.pause();
        });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.video?.pause(); this.controller?.abort(); this.videoController?.abort(); this.observer?.disconnect(); }
      loadVideo() {
        const variant = this.mobile.matches && this.querySelector('template[data-video="mobile"]') ? 'mobile' : 'desktop';
        if (this.variant === variant && this.video && !this.videoController?.signal.aborted) return;
        this.video?.pause();
        this.videoController?.abort();
        this.videoController = new AbortController();
        const template = this.querySelector(`template[data-video="${variant}"]`);
        this.host.replaceChildren(template.content.cloneNode(true));
        this.video = this.host.querySelector('video');
        this.variant = variant;
        this.video.controls = false;
        this.video.muted = true;
        ['play', 'pause', 'ended', 'error'].forEach(name => this.video.addEventListener(name, () => this.sync(), { signal: this.videoController.signal }));
        this.button.hidden = false;
        this.sync();
        this.maybePlay();
      }
      sync() {
        this.button.setAttribute('aria-label', this.video.paused ? this.dataset.play : this.dataset.pause);
        this.button.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ';
      }
      maybePlay() {
        if (!this.visible || document.hidden || this.reduced.matches || this.userPaused || this.dataset.autoplay !== 'true') return;
        this.video.play().catch(() => this.sync());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-media-text"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-media-text')) {
    customElements.define('hview-media-text', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        this.host = this.querySelector('.hvmt__video-host');
        if (!this.host) return;
        const options = { signal: this.controller.signal };
        this.button = this.querySelector('.hvmt__play');
        this.mobile = matchMedia('(max-width:749px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.userPaused = false;
        this.button.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.video.play().catch(() => this.sync());
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.mobile.addEventListener('change', () => this.loadVideo(), options);
        this.reduced.addEventListener('change', () => { this.video.pause(); this.maybePlay(); }, options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.video.pause(); else this.maybePlay();
        }, options);
        this.loadVideo();
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          if (this.visible) this.maybePlay(); else this.video.pause();
        });
        this.observer.observe(this);
      }
      disconnectedCallback() { this.video?.pause(); this.controller?.abort(); this.videoController?.abort(); this.observer?.disconnect(); }
      loadVideo() {
        const variant = this.mobile.matches && this.querySelector('template[data-video="mobile"]') ? 'mobile' : 'desktop';
        if (this.variant === variant && this.video && !this.videoController?.signal.aborted) return;
        this.video?.pause();
        this.videoController?.abort();
        this.videoController = new AbortController();
        const template = this.querySelector(`template[data-video="${variant}"]`);
        this.host.replaceChildren(template.content.cloneNode(true));
        this.video = this.host.querySelector('video');
        this.variant = variant;
        this.video.controls = false;
        this.video.muted = true;
        ['play', 'pause', 'ended', 'error'].forEach(name => this.video.addEventListener(name, () => this.sync(), { signal: this.videoController.signal }));
        this.button.hidden = false;
        this.sync();
        this.maybePlay();
      }
      sync() {
        this.button.setAttribute('aria-label', this.video.paused ? this.dataset.play : this.dataset.pause);
        this.button.firstElementChild.textContent = this.video.paused ? '▶' : 'Ⅱ';
      }
      maybePlay() {
        if (!this.visible || document.hidden || this.reduced.matches || this.userPaused || this.dataset.autoplay !== 'true') return;
        this.video.play().catch(() => this.sync());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-product-checklist"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-product-checklist')) {
    customElements.define('hview-product-checklist', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort(); this.observer?.disconnect();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.details = this.querySelector('details');
        this.list = this.querySelector('.hvcl__list');
        this.controls = this.querySelector('.hvcl__controls');
        this.previous = this.querySelector('.hvcl__prev');
        this.next = this.querySelector('.hvcl__next');
        this.previous?.addEventListener('click', () => this.step(-1), options);
        this.next?.addEventListener('click', () => this.step(1), options);
        this.list.addEventListener('scroll', () => this.update(), { ...options, passive:true });
        this.list.addEventListener('keydown', event => {
          if (event.target !== this.list || this.dataset.mode !== 'carousel') return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault(); this.step(event.key === 'ArrowLeft' ? -1 : 1);
          }
        }, options);
        this.details.addEventListener('toggle', () => this.update(), options);
        this.addEventListener('shopify:block:select', event => {
          const item = [...this.querySelectorAll('.hvcl__item')].find(item => item.dataset.blockId === event.detail.blockId);
          if (!item) return;
          this.details.open = true;
          requestAnimationFrame(() => {
            if (!this.isConnected || this.dataset.mode !== 'carousel') return;
            this.list.scrollBy({left:item.getBoundingClientRect().left - this.list.getBoundingClientRect().left - 4,behavior:'instant'});
            this.update();
          });
        }, options);
        if ('ResizeObserver' in window) {
          this.observer = new ResizeObserver(() => this.update()); this.observer.observe(this.list);
        } else { window.addEventListener('resize', () => this.update(), options); }
        this.update();
      }
      update() {
        if (!this.controls || !this.details.open) return;
        const max = this.list.scrollWidth - this.list.clientWidth;
        this.controls.hidden = max <= 2;
        this.previous.disabled = this.list.scrollLeft <= 2;
        this.next.disabled = this.list.scrollLeft >= max - 2;
      }
      step(direction) {
        const card = this.list.querySelector('.hvcl__item');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.list).gap) || 0;
        this.list.scrollBy({left:direction*(card.getBoundingClientRect().width+gap),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }
      disconnectedCallback() { this.controller?.abort(); this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-product-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-product-quiz')) {
    customElements.define('hview-product-quiz', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.answers = {};
        this.current = 0;
        this.showingResults = false;
        this.questions = [...this.querySelectorAll('.hvquiz__question')];
        this.cards = [...this.querySelectorAll('.hvquiz__product')];
        this.app = this.querySelector('.hvquiz__app');
        this.results = this.querySelector('.hvquiz__results');
        this.navigation = this.querySelector('.hvquiz__navigation');
        this.progress = this.querySelector('.hvquiz__progress ol');
        this.editorMessage = this.querySelector('.hvquiz__editor-message');
        this.limit = Math.max(1, Number(this.dataset.limit) || 4);
        if (!this.app || !this.progress) return;
        this.steps = this.questions.map((question, index) => {
          const li = document.createElement('li');
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'hvquiz__step';
          button.dataset.step = index; button.textContent = index + 1;
          button.setAttribute('aria-label', `${index + 1}. ${question.querySelector('h3').textContent}`);
          li.append(button); return li;
        });
        this.progress.replaceChildren(...this.steps);
        this.invalidQuestions = this.questions.length === 0 || this.questions.some(q => !q.querySelector('[data-answer]'));
        this.cards.forEach(card => {
          card.rules = {};
          card.invalidRule = false;
          this.questions.forEach(question => {
            const id = question.dataset.question;
            const rule = this.parseRule(card.getAttribute(`data-rule-${id}`));
            const available = new Set([...question.querySelectorAll('[data-answer]')].map(b => Number(b.dataset.answer)));
            if (rule === false || (rule && rule.some(value => !available.has(value)))) card.invalidRule = true;
            card.rules[id] = rule;
          });
        });
        this.app.hidden = this.invalidQuestions;
        this.reportConfiguration();
        this.addEventListener('click', event => this.handleClick(event), { signal: this.controller.signal });
        this.addEventListener('shopify:block:select', event => {
          const selected = this.cards.find(card => card.dataset.blockId === event.detail.blockId);
          if (!selected || this.invalidQuestions || this.dataset.designMode !== 'true') return;
          this.showEditorCard(selected);
        }, { signal: this.controller.signal });
        this.addEventListener('shopify:block:deselect', () => {
          if (this.editorPreview) { this.editorPreview = false; this.render(false); this.reportConfiguration(); }
        }, { signal: this.controller.signal });
        if (!this.invalidQuestions) this.render(false);
      }
      disconnectedCallback() { this.controller?.abort(); }
      parseRule(raw) {
        if (!raw || !raw.trim()) return null;
        const normalized = raw.replace(/[０-９]/g, c => String.fromCharCode(c.charCodeAt(0) - 65248)).trim();
        const parts = normalized.split(/[,，、;；\s]+/).filter(Boolean);
        if (!parts.length || parts.some(p => !/^[1-9]\d*$/.test(p))) return false;
        return [...new Set(parts.map(Number))];
      }
      reportConfiguration() {
        if (!this.editorMessage) return;
        const issues = [];
        if (this.invalidQuestions) issues.push('请至少填写一道问题，并为每道已启用的问题填写至少一个答案。清空问题标题可停用该题。');
        if (!this.cards.some(card => card.dataset.productId)) issues.push('请添加“推荐商品”区块并选择可售商品。商品区块中的答案编号需要与问题选项对应。');
        const invalid = this.cards.filter(card => card.invalidRule);
        if (invalid.length) issues.push(`有 ${invalid.length} 个商品区块的答案编号无效，已从推荐中排除。请只填现有答案编号，如 1,3。`);
        this.editorMessage.textContent = issues.join('\n');
        this.editorMessage.hidden = issues.length === 0;
      }
      handleClick(event) {
        const button = event.target.closest('button');
        if (!button || !this.contains(button) || button.disabled || this.invalidQuestions) return;
        if (button.hasAttribute('data-answer')) {
          const question = button.closest('.hvquiz__question');
          if (question !== this.questions[this.current] || this.showingResults) return;
          const id = question.dataset.question;
          const choice = Number(button.dataset.answer);
          if (this.answers[id] !== choice) this.questions.slice(this.current + 1).forEach(q => delete this.answers[q.dataset.question]);
          this.answers[id] = choice;
          if (this.dataset.autoAdvance === 'true') this.advance(); else this.render(false);
        } else if (button.classList.contains('hvquiz__next')) this.advance();
        else if (button.classList.contains('hvquiz__back')) { this.current = Math.max(0, this.current - 1); this.render(true); }
        else if (button.hasAttribute('data-step')) { this.showingResults = false; this.current = Number(button.dataset.step); this.render(true); }
        else if (button.classList.contains('hvquiz__restart')) {
          this.answers = {}; this.current = 0; this.showingResults = false; this.editorPreview = false;
          this.reportConfiguration(); this.render(true);
        }
      }
      advance() {
        if (!this.answers[this.questions[this.current].dataset.question]) return;
        if (this.current < this.questions.length - 1) this.current += 1;
        else this.showingResults = true;
        this.render(true);
      }
      matches(card) {
        return Boolean(card.dataset.productId) && !card.invalidRule && this.questions.every(q => {
          const id = q.dataset.question;
          return this.answers[id] && (card.rules[id] === null || card.rules[id].includes(this.answers[id]));
        });
      }
      render(moveFocus) {
        if (this.editorPreview) this.reportConfiguration();
        this.editorPreview = false;
        this.questions.forEach((question, index) => {
          question.hidden = this.showingResults || index !== this.current;
          question.querySelectorAll('[data-answer]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.answer) === this.answers[question.dataset.question])));
        });
        this.steps.forEach((li, index) => {
          const button = li.firstElementChild;
          button.disabled = index > this.current && !this.answers[this.questions[index].dataset.question];
          if (!this.showingResults && index === this.current) button.setAttribute('aria-current', 'step'); else button.removeAttribute('aria-current');
          button.dataset.complete = Boolean(this.answers[this.questions[index].dataset.question]);
        });
        this.navigation.hidden = this.showingResults;
        this.querySelector('.hvquiz__back').hidden = this.current === 0;
        const next = this.querySelector('.hvquiz__next');
        next.hidden = this.dataset.autoAdvance === 'true';
        next.disabled = !this.answers[this.questions[this.current].dataset.question];
        const last = this.current === this.questions.length - 1;
        next.querySelector('[data-next-label]').hidden = last;
        next.querySelector('[data-result-label]').hidden = !last;
        this.results.hidden = !this.showingResults;
        if (this.showingResults) {
          const seen = new Set(); let count = 0;
          this.cards.forEach(card => {
            const show = count < this.limit && this.matches(card) && !seen.has(card.dataset.productId);
            card.hidden = !show;
            if (show) { seen.add(card.dataset.productId); count += 1; }
          });
          this.querySelector('.hvquiz__empty').hidden = count > 0;
          const selected = this.questions.map(question => {
            const li = document.createElement('li');
            const answer = question.querySelector(`[data-answer="${this.answers[question.dataset.question]}"]`);
            li.textContent = answer ? answer.textContent : '';
            return li;
          });
          this.querySelector('.hvquiz__selection').replaceChildren(...selected);
        }
        if (moveFocus) (this.showingResults ? this.results : this.questions[this.current]).querySelector('h3').focus();
      }
      showEditorCard(card) {
        this.editorPreview = true;
        this.questions.forEach(q => q.hidden = true);
        this.navigation.hidden = true; this.results.hidden = false;
        this.querySelector('.hvquiz__empty').hidden = true;
        this.querySelector('.hvquiz__selection').replaceChildren();
        this.cards.forEach(item => item.hidden = item !== card);
        if (this.editorMessage) {
          this.editorMessage.textContent = '正在预览选中的商品区块，此预览不代表问答匹配结果。取消选中或点击“重新选择”可恢复问答。';
          this.editorMessage.hidden = false;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-spec-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-spec-gallery')) {
    customElements.define('hview-spec-gallery', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.slides = [...this.querySelectorAll('.hvsg__slide')];
        this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        this.status = this.querySelector('.hvsg__status');
        const arrows = this.querySelector('.hvsg__arrows');
        if (arrows) arrows.hidden = false;
        this.querySelector('.hvsg__prev')?.addEventListener('click', () => this.select(this.index - 1), options);
        this.querySelector('.hvsg__next')?.addEventListener('click', () => this.select(this.index + 1), options);
        this.addEventListener('keydown', event => {
          if (!event.target.closest('.hvsg__arrow')) return;
          if (event.key === 'ArrowLeft') { event.preventDefault(); this.select(this.index - 1); }
          if (event.key === 'ArrowRight') { event.preventDefault(); this.select(this.index + 1); }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, options);
        this.querySelectorAll('.hvsg__frame').forEach(frame => {
          frame.addEventListener('dragstart', event => event.preventDefault(), options);
          frame.addEventListener('pointerdown', event => {
            if (!event.isPrimary) { this.start = null; return; }
            this.start = { x:event.clientX, y:event.clientY, id:event.pointerId };
          }, options);
          frame.addEventListener('pointercancel', () => { this.start = null; }, options);
          frame.addEventListener('pointerup', event => {
            const start = this.start;
            this.start = null;
            if (!start || start.id !== event.pointerId) return;
            const dx = event.clientX - start.x;
            const dy = event.clientY - start.y;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) this.select(this.index + (dx < 0 ? 1 : -1));
          }, options);
        });
      }
      disconnectedCallback() { this.controller?.abort(); this.start = null; }
      select(index) {
        if (!this.slides.length) return;
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        if (this.status) this.status.textContent = `${this.index + 1} / ${this.slides.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-specification-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-specification-tabs')) {
    customElements.define('hview-specification-tabs', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => { if (this.isConnected) this.setup(); });
      }
      setup() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal:this.controller.signal };
        this.tabs = [...this.querySelectorAll('.hvspt__tab')];
        this.panels = [...this.querySelectorAll('.hvspt__panel')];
        this.scroller = this.querySelector('.hvspt__tabs');
        if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
        this.tabs.forEach((tab, index) => {
          this.panels[index].setAttribute('role', 'tabpanel');
          this.panels[index].setAttribute('aria-labelledby', tab.id);
          this.panels[index].tabIndex = 0;
          tab.addEventListener('click', () => this.select(index, true), options);
          tab.addEventListener('keydown', event => {
            let next;
            const rtl = getComputedStyle(this).direction === 'rtl';
            if (event.key === 'ArrowRight') next = (index + (rtl ? -1 : 1) + this.tabs.length) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index + (rtl ? 1 : -1) + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next, true);
            this.tabs[next].focus({ preventScroll:true });
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const selected = [...this.querySelectorAll('[data-hvspt-block-id]')].find(el => el.dataset.hvsptBlockId === event.detail?.blockId);
          const panel = selected?.closest('.hvspt__panel');
          const index = this.panels.indexOf(panel);
          if (index < 0) return;
          this.select(index, true);
          if (selected.matches('details')) selected.open = true;
        }, options);
        this.classList.add('hvspt--enhanced');
        this.scroller.hidden = false;
        const initial = Number.isInteger(this.index) ? this.index : (Number(this.dataset.initialTab) || 1) - 1;
        this.select(Math.max(0, Math.min(initial, this.tabs.length - 1)), true);
      }
      select(index, reveal = false) {
        if (!this.tabs[index] || !this.panels[index]) return;
        this.index = index;
        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          this.panels[i].hidden = !active;
        });
        if (reveal && this.scroller) {
          const tab = this.tabs[index].getBoundingClientRect();
          const box = this.scroller.getBoundingClientRect();
          if (tab.left < box.left) this.scroller.scrollLeft += tab.left - box.left;
          else if (tab.right > box.right) this.scroller.scrollLeft += tab.right - box.right;
        }
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-specifications"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-specifications')) {
    customElements.define('hview-specifications', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.addEventListener('shopify:block:select', event => {
          const group = [...this.querySelectorAll('.hvspec__group')].find(item => item.dataset.blockId === event.detail.blockId);
          if (group) group.open = true;
        }, { signal:this.controller.signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hview-storage-tabs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hview-storage-tabs')) {
    customElements.define('hview-storage-tabs', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.tabs = [...this.querySelectorAll('[role="tab"]')];
        this.panels = [...this.querySelectorAll('[role="tabpanel"]')];
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index), options);
          tab.addEventListener('keydown', event => {
            let next;
            if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
            if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = this.tabs.length - 1;
            if (next === undefined) return;
            event.preventDefault();
            this.select(next);
            this.tabs[next].focus();
          }, options);
        });
        this.addEventListener('shopify:block:select', event => {
          const index = this.panels.findIndex(panel => panel.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.select(index);
        }, options);
      }
      disconnectedCallback() { this.controller?.abort(); }
      select(index) {
        if (!this.panels[index]) return;
        this.tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          this.panels[i].hidden = i !== index;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-nav"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hview-product-nav')) {
  customElements.define('hview-product-nav', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.wrapper = this.closest('.shopify-section') || this.parentElement;
      this.links = [...this.querySelectorAll('[data-target]')];
      this.strip = this.querySelector('.hv-nav__links');
      this.cta = this.querySelector('[data-cta]');
      this.status = this.querySelector('[data-status]');
      this.originals = new Map();
      this.addEventListener('click', event => this.onClick(event), options);
      this.addEventListener('keydown', event => this.onKey(event), options);
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(name => {
        window.addEventListener(name, () => this.cancelAlignment(), { ...options, passive: true, capture: true });
      });
      window.addEventListener('hashchange', () => this.followHash(), options);
      window.addEventListener('popstate', () => this.followHash(), options);
      document.addEventListener('change', () => this.syncCart(), options);
      ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(name => {
        document.addEventListener(name, () => this.queueRefresh(), options);
      });
      ['shopify:section:select', 'shopify:block:select'].forEach(name => {
        document.addEventListener(name, event => {
          const link = event.target.closest('[data-target]');
          const group = this.groups?.find(group => group.link === link || group.nodes.some(node => node === event.target || node.contains(event.target)));
          if (group) this.activate(group.id, { scroll: false });
        }, options);
      });
      this.mutationObserver = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.queueRefresh();
      });
      this.mutationObserver.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
      this.refresh();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.mutationObserver?.disconnect();
      clearTimeout(this.refreshTimer);
      this.cancelAlignment();
      this.restore();
    }
    queueRefresh() {
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => { if (this.isConnected) this.refresh(); }, 100);
    }
    get offset() {
      return Math.max(0, parseFloat(getComputedStyle(this.wrapper).getPropertyValue('--hv-nav-top')) || 0);
    }
    get boundary() {
      return this.offset + (this.dataset.sticky === 'true' ? this.getBoundingClientRect().height : 0) + 12;
    }
    get scrollContainer() {
      for (let node = this.wrapper.parentElement; node && node !== document.body && node !== document.documentElement; node = node.parentElement) {
        if (/^(auto|scroll|overlay)$/.test(getComputedStyle(node).overflowY)) return node;
      }
      return document.scrollingElement || document.documentElement;
    }
    get scrollViewportHeight() {
      const root = this.scrollContainer;
      return root === document.scrollingElement ? window.innerHeight : root.clientHeight;
    }
    contentScrollTop(target) {
      const root = this.scrollContainer;
      const rect = target.getBoundingClientRect();
      const origin = root === document.scrollingElement ? 0 : root.getBoundingClientRect().top + root.clientTop;
      return Math.max(0, rect.top - origin + root.scrollTop - this.boundary);
    }
    scrollToPosition(top, behavior = 'instant') {
      this.scrollContainer.scrollTo({ top, behavior });
    }
    remember(element, attributes) {
      if (!this.originals.has(element)) this.originals.set(element, new Map());
      const saved = this.originals.get(element);
      attributes.forEach(name => { if (!saved.has(name)) saved.set(name, element.getAttribute(name)); });
    }
    restore() {
      this.originals?.forEach((attributes, element) => attributes.forEach((value, name) => {
        if (value === null) element.removeAttribute(name);
        else element.setAttribute(name, value);
      }));
      this.originals?.clear();
    }
    hashId() {
      try { return decodeURIComponent(location.hash.slice(1)); } catch { return ''; }
    }
    refresh() {
      // Do not reparent theme sections: their existing styles and controllers keep ownership.
      this.restore();
      this.groups = [];
      this.ready = false;
      this.syncCart();
      const siblings = [...this.wrapper.parentElement.children];
      const navIndex = siblings.indexOf(this.wrapper);
      const endIndex = siblings.findIndex((node, index) => index > navIndex && node.querySelector('[data-hv-tabs-end]'));
      const entries = this.links.map(link => {
        const matches = document.querySelectorAll('[id="' + CSS.escape(link.dataset.target) + '"]');
        const target = matches.length === 1 ? matches[0] : null;
        const section = target?.closest('.shopify-section');
        return { id: link.dataset.target, link, target, section, duplicate: matches.length > 1, index: siblings.indexOf(section) };
      });
      const valid = entries.filter(entry => entry.target);
      const invalid = endIndex < 0 || !valid.length || entries.some(entry => entry.duplicate) || new Set(valid.map(entry => entry.index)).size !== valid.length ||
        new Set(entries.map(entry => entry.id)).size !== entries.length ||
        valid.some(entry => entry.index <= navIndex || entry.index >= endIndex);
      if (invalid) {
        this.links.forEach(link => { link.hidden = false; });
        if (window.Shopify?.designMode) this.status.textContent = '请按安装说明配置：导航、各栏目锚点与内容、标签内容结束。它们必须是同级模块，锚点 ID 不可重复。';
        return; // Fail open: never hide content when the boundaries are unsafe.
      }
      this.status.textContent = '';
      const ordered = [...valid].sort((a, b) => a.index - b.index);
      this.remember(this.strip, ['role']);
      this.strip.setAttribute('role', 'tablist');
      ordered.forEach((entry, index) => {
        const stop = ordered[index + 1]?.index ?? endIndex;
        const nodes = siblings.slice(entry.index, stop);
        const panels = nodes.filter(node => node.classList.contains('shopify-section'));
        const tabId = this.wrapper.id + '-tab-' + index;
        this.remember(entry.link, ['id', 'role', 'aria-selected', 'aria-controls', 'tabindex', 'hidden', 'aria-disabled']);
        entry.link.id = tabId;
        entry.link.setAttribute('role', 'tab');
        entry.link.removeAttribute('aria-disabled');
        entry.link.hidden = false;
        panels.forEach((panel, panelIndex) => {
          this.remember(panel, ['id', 'role', 'aria-labelledby', 'tabindex']);
          if (!panel.id) panel.id = tabId + '-panel-' + panelIndex;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
          panel.setAttribute('tabindex', '0');
        });
        entry.link.setAttribute('aria-controls', panels.map(panel => panel.id).join(' '));
        nodes.forEach(node => this.remember(node, ['data-hv-tab-hidden']));
        this.groups.push({ ...entry, nodes });
      });
      entries.filter(entry => !entry.target).forEach(({ link }) => {
        this.remember(link, ['hidden', 'role', 'aria-disabled', 'tabindex', 'aria-selected']);
        link.hidden = this.dataset.hideMissing === 'true' && !window.Shopify?.designMode;
        link.setAttribute('role', 'tab');
        link.setAttribute('aria-disabled', 'true');
        link.setAttribute('tabindex', '-1');
        link.setAttribute('aria-selected', 'false');
      });
      this.ready = true;
      this.endMarker = siblings[endIndex].querySelector('[data-hv-tabs-end]');
      this.remember(this.endMarker, ['style']);
      const hash = this.hashId();
      const selected = this.groups.find(group => group.id === this.activeId) || this.groups.find(group => group.id === hash) ||
        this.groups.find(group => group.id === this.dataset.defaultTab) || this.groups[0];
      this.activate(selected.id, { scroll: false, notify: false });
    }
    activate(id, { scroll = false, history = false, focus = false, notify = true } = {}) {
      const selected = this.groups.find(group => group.id === id);
      if (!selected) return;
      this.activeId = id;
      this.groups.forEach(group => {
        const active = group === selected;
        group.link.setAttribute('aria-selected', String(active));
        group.link.setAttribute('tabindex', active ? '0' : '-1');
        group.nodes.forEach(node => {
          if (active) node.removeAttribute('data-hv-tab-hidden');
          else {
            node.setAttribute('data-hv-tab-hidden', '');
            node.querySelectorAll('video, audio').forEach(media => media.pause());
          }
        });
      });
      if (history && location.hash !== '#' + encodeURIComponent(id)) window.history.pushState(null, '', '#' + encodeURIComponent(id));
      if (focus) selected.link.focus({ preventScroll: true });
      const box = selected.link.getBoundingClientRect(), viewport = this.strip.getBoundingClientRect();
      if (box.left < viewport.left || box.right > viewport.right) this.strip.scrollLeft += box.left - viewport.left - (viewport.width - box.width) / 2;
      // Reserve enough space for even a short tab to align below the sticky bar.
      // This owned, empty end marker does not change any theme content styles.
      if (this.endMarker) this.endMarker.style.height = '0px';
      const desired = this.contentScrollTop(selected.nodes[0]);
      if (this.endMarker) {
        // Measure with a viewport of space first, so a parent's min-height does
        // not absorb the spacer and leave the scroll position clamped short.
        this.endMarker.style.height = this.scrollViewportHeight + 'px';
        const extra = Math.max(0, Math.ceil(desired + 2 * this.scrollViewportHeight - this.scrollContainer.scrollHeight));
        this.endMarker.style.height = extra + 'px';
      }
      if (scroll) {
        // Return to the start of this shared content area, not the old anchor position.
        // Use the newly selected section, which now occupies the shared content area.
        this.scrollToPosition(desired);
      }
      if (notify) selected.nodes.forEach(node => node.dispatchEvent(new CustomEvent('hview:tab:shown', { bubbles: true, detail: { id } })));
      if (scroll) this.scheduleAlignment(id);
    }
    cancelAlignment() {
      cancelAnimationFrame(this.alignFrame);
      clearTimeout(this.alignTimer);
      this.alignToken = (this.alignToken || 0) + 1;
    }
    alignSelected(id) {
      if (!this.isConnected || !this.ready || this.activeId !== id) return;
      const group = this.groups.find(group => group.id === id);
      if (!group) return;
      // Read layout BEFORE scrollY: hiding a long section can clamp scrollY
      // during layout. Mixing pre-layout scrollY with a new rectangle is stale.
      const desired = this.contentScrollTop(group.nodes[0]);
      if (this.endMarker) {
        this.endMarker.style.height = this.scrollViewportHeight + 'px';
        const extra = Math.max(0, Math.ceil(desired + 2 * this.scrollViewportHeight - this.scrollContainer.scrollHeight));
        this.endMarker.style.height = extra + 'px';
      }
      this.scrollToPosition(desired);
    }
    scheduleAlignment(id) {
      this.cancelAlignment();
      const token = this.alignToken;
      const align = () => { if (token === this.alignToken) this.alignSelected(id); };
      // Allow section controllers, browser anchoring and sticky-header layout
      // to settle. Cancel pending correction immediately on new user input.
      this.alignFrame = requestAnimationFrame(() => {
        align();
        this.alignFrame = requestAnimationFrame(align);
      });
      this.alignTimer = setTimeout(align, 180);
    }
    followHash() {
      if (!this.ready) return;
      const id = this.hashId();
      const nested = document.getElementById(id);
      const group = this.groups.find(group => group.id === id || (nested && group.nodes.some(node => node.contains(nested))));
      if (group) this.activate(group.id, { scroll: true });
      else if (!id) this.activate(this.groups.find(group => group.id === this.dataset.defaultTab)?.id || this.groups[0].id, { scroll: true });
    }
    onKey(event) {
      const current = event.target.closest('[role="tab"]');
      if (!current || !this.ready) return;
      const tabs = this.links.filter(link => this.groups.some(group => group.link === link));
      const index = tabs.indexOf(current);
      let next;
      if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
      if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
      if (event.key === 'Home') next = tabs[0];
      if (event.key === 'End') next = tabs[tabs.length - 1];
      if (next) { event.preventDefault(); next.focus({ preventScroll: true }); }
      if (event.key === ' ' || event.key === 'Enter') {
        event.preventDefault();
        this.activate(current.dataset.target, { scroll: true, history: true, focus: true });
      }
    }
    onClick(event) {
      const link = event.target.closest('[data-target]');
      if (link && this.contains(link) && this.ready) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        event.stopPropagation();
        this.activate(link.dataset.target, { scroll: true, history: true, focus: true });
      }
      if (event.target.closest('[data-cta]')) this.addToCart();
    }
    goTo(target) {
      if (!target) return;
      this.scrollToPosition(this.contentScrollTop(target));
      const temporary = !target.hasAttribute('tabindex');
      if (temporary) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      if (temporary) target.removeAttribute('tabindex');
    }
      getCartForm() {
        const selector = this.dataset.formSelector.trim();
        if (selector) {
          try {
            const matches = document.querySelectorAll(selector);
            return matches.length === 1 && matches[0] instanceof HTMLFormElement ? matches[0] : null;
          } catch { return null; }
        }
        const forms = [...document.forms].filter(form => {
          const action = new URL(form.action, location.href);
          if (action.origin !== location.origin || !/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) return false;
          if (form.closest('dialog, [role="dialog"], quick-add-modal, product-recommendations')) return false;
          if (!(form.compareDocumentPosition(this) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
          const productId = form.querySelector('[name="product-id"]')?.value;
          return (!productId || productId === this.dataset.productId) && !!form.querySelector('[name="id"]');
        });
        // Multiple forms are ambiguous; require a specific form selector.
        return forms.length === 1 ? forms[0] : null;
      }
      getSubmitter(form) {
        return form && [...form.elements].find(element =>
          (element instanceof HTMLButtonElement || element instanceof HTMLInputElement) &&
          element.type === 'submit' && element.name === 'add');
      }
      syncCart() {
        if (!this.cta) return;
        const button = this.getSubmitter(this.getCartForm());
        const unavailable = button && (button.matches(':disabled') || button.getAttribute('aria-disabled') === 'true');
        this.cta.disabled = !!unavailable;
        this.cta.textContent = unavailable ? (button.textContent.trim() || button.value || '現在購入できません') : this.dataset.ctaLabel;
      }
      addToCart() {
        const form = this.getCartForm();
        const button = this.getSubmitter(form);
        this.syncCart();
        if (this.cta?.disabled) return;
        if (!form || !button || !form.querySelector('[name="id"]')?.value) {
          this.status.textContent = 'ページ上部の商品購入欄で仕様・数量を確認して追加してください。';
          if (form) this.goTo(form);
          else this.scrollToPosition(0);
          return;
        }
        this.status.textContent = '';
        // Bring validation, cart errors and variant selection into view.
        this.goTo(form, false);
        button.click();
        this.syncCart();
      }
  });
}


  } catch(e) { console.error(e); }
})();
})();
